module.exports = __webpack_public_path__ + "img/electrico.ecf015b8.png";